export default __webpack_public_path__ + "64c2d5762df93a5b22c1f56678a9222e.svg";